import React from 'react';
import { useTranslation } from 'react-i18next';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export default function LoadingSpinner({ size = 'md', className = '' }: LoadingSpinnerProps) {
  const { t } = useTranslation('common');
  
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-6 h-6 border-3',
    lg: 'w-8 h-8 border-4'
  };

  return (
    <div 
      className={`
        ${sizeClasses[size]}
        border-gray-300 
        border-t-blue-500 
        rounded-full 
        animate-spin
        ${className}
      `}
      role="status"
      aria-label={t('loading.title')}
    />
  );
}